import type { HTMLProps, PropsWithChildren, ReactElement } from 'react'
import type { LinkProps } from 'react-router'
import { Link as ReactRouterLink, NavLink, useLocation } from 'react-router'
import { omit } from 'lodash-es'
import cc from 'classcat'

import { withQueryAndScope } from '../../urlGeneratorsPlain'

type Props = (LinkProps | HTMLProps<HTMLAnchorElement>) & {
  readonly activeClassName?: string
}
export default function Link(props: PropsWithChildren<Props>): ReactElement {
  const location = useLocation()

  if ('to' in props && props.to) {
    if (props.activeClassName) {
      const { to, activeClassName, className, ...other } = props
      return (
        <NavLink
          end
          to={withQueryAndScope(to, location)}
          className={({ isActive }) => cc([className, isActive && activeClassName])}
          {...other}
        />
      )
    }

    const { to, ...other } = props
    return <ReactRouterLink to={withQueryAndScope(to, location)} {...other} />
  } else {
    const htmlAttributes = omit(props, ['activeClassName'])
    // The component using this is responsible for that.
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a {...htmlAttributes} />
  }
}
